import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton,ManText } from '@craft-design-system/core-components-react';
import useGraphRadio from '../../utils/useGraphRadio';
import Shimmer_graph from '../shimmer_graph';
import ifav from './ifav.png';
import energyComponentsTable from '../../assets/images/BBP_CBP_consumption.png';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { useFilterContext } from '../FilterContext';
import { useResetContext } from '../ResetContext';

const Energy_consumption_per_speed_class_BBP = ({ value }) => {
  const [BBP_graph, set_BBP_graph] = useState(null)
  const radio_query = useGraphRadio();
  const { filterdata } = useFilterContext();
  const { resetdata } = useResetContext();
  const { startDate, endDate } = filterdata || {};
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: '800px' }}>
      <Popover.Body>
        <div dangerouslySetInnerHTML={{
          __html: `<b>Energy Consumption per Speed Class (BBP):</b> The energy consumption per speed class of battery generation BBP is displayed with its components. This KPI is split up among BBP and CBP because the available components of energy consumption differ among the battery generations.<br/><br/>
          
          <b>Available Components for BBP and CBP:</b><br/>
          <img src="${energyComponentsTable}" alt="Energy Consumption Components" style="width: 200%; max-width: 700px; margin: 10px 0;"/><br/>
          
          <b>Condition for standing:</b><br/>
          Sum of time where vehiclespeedclass_value_filled IN ('SC_STANDSTILL')<br/><br/>
          
          <b>Condition for driving:</b><br/>
          Sum of time where vehiclespeedclass_value_filled in respective speed classes<br/><br/>
          
          <b>Time series data:</b><br/>
          If multiple vehicles are selected average values are displayed. Days without data are not taken into account for the calculation.`
        }} />
      </Popover.Body>
    </Popover>
  );

  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };

  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);

      //console.log(value.vin_short)
      radio_query({vins_short:[value.vin_short],radio_value:radio_buttons_test,columnname:'BBP Speed Class| Standstill',startDate,endDate}).then(data => {
        set_BBP_graph(JSON.parse(data['jsonData']));
        setIsLoading(false);
      });
    }
  }, [radio_buttons_test, value?.vin_short, startDate, endDate]);

  useEffect(() => {
    //console.log('testing23456', BBP_graph);
  }, [BBP_graph]);

  useEffect(() => {
    if (!BBP_graph && value?.standstill_consumption_BBP) {
      try {
        set_BBP_graph(JSON.parse(value.standstill_consumption_BBP));
      } catch (error) {
        console.error("Error parsing fallback standstill_consumption JSON", error);
      }
    }
  }, [value, BBP_graph]);
  

  

  return (
<Card className='card_ride' >      <div className="card-title">
      <ManText className="card-title-text" variant="component-l" as="span" size="l" 
       style={{}}>
      BBP Energy consumption per speed class (and while standing with engine turned on)
      </ManText>
      <OverlayTrigger trigger="hover" placement="left" overlay={popover}>

      <img className="man-logovv1" src={ifav}/>
      </OverlayTrigger>

      <ManRadioButtonGroup 
        name="BBP Speed Class| Standstill"
        invalid="false"
        onManChange={handleSelectChange1}
      >
        <ManRadioButton name="Energy Throughput per Speed Class" label="Yesterday" value="Yesterday" checked />
        <ManRadioButton name="Energy Throughput per Speed Class" label="Current month" value="Current month" />
        <ManRadioButton name="Energy Throughput per Speed Class" label="Current year" value="Current year" />
      </ManRadioButtonGroup>
      </div>
      {isLoading ? (
        <Shimmer_graph />
      ) : !BBP_graph || !BBP_graph.data || BBP_graph.data.length === 0 ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '300px',
          textAlign: 'center',
          border: '1px solid #e0e0e0',
          borderRadius: '5px',
          background: '#fafafa',
          marginTop: '10px'
        }}>
          <div>
            <ManText variant="headline-m" as="div" style={{ color: '#59636D', marginBottom: '8px' }}>
              No Data Available
            </ManText>
            <ManText variant="body-m" as="div" style={{ color: '#838a92' }}>
              There is no data available for the selected filters
            </ManText>
          </div>
        </div>
      ) : (
        <Plot 
          data={BBP_graph.data} 
          layout={{
              ...BBP_graph.layout,
              autosize: true,
              responsive: true,
              margin: { t: 10, r: 10, l: 10, b: 140 }
          }}
          style={{ width: '100%', height: '100%' }}
          useResizeHandler={true}
        />
      )}    
      </Card>
  );
};

Energy_consumption_per_speed_class_BBP.propTypes = {
  value: PropTypes.object.isRequired,
};

export default Energy_consumption_per_speed_class_BBP;